import createEasingFunction from '../animation/createEasingFunction';

const ease = createEasingFunction('ease');

const scrollTo = (target, options = {}) => {
  let startValue       = window.pageYOffset,
      targetValue      = (typeof target === 'number')
        ? target + (options.offset || 0)
        : Math.ceil(startValue + target.getBoundingClientRect().top + (options.offset || 0)),
      changeInValue    = targetValue - startValue,
      totalIterations  = options.duration / 1000 * 60, // 60 fps
      currentIteration = 0,
      currentValue,
      raf;

  const animate = () => {
    if (currentIteration < totalIterations) {
      const progress = ease(currentIteration / totalIterations);
      currentValue = (progress * changeInValue) + startValue;
      currentIteration++;
      window.scrollTo(window.scrollX, currentValue);
      raf = window.requestAnimationFrame(animate);
    } else {
      window.scrollTo(window.scrollX, targetValue);
      
      if (typeof options.callback === 'function') {
        options.callback();
      }
    }

    return raf;
  };

  if (!options.duration) {
    window.scrollTo(window.scrollX, targetValue);
  } else {
    return animate();
  }
};

export default scrollTo;